export default __webpack_public_path__ + "static/media/8.08429d57.jpg";